import produce from 'immer';

import {
	SET_APPLICATION_LEVEL_FULFILLED,
	SUBMIT_APPLICATION_FORM_PENDING,
	SUBMIT_APPLICATION_FORM_FULFILLED,
	SUBMIT_APPLICATION_FORM_FAILED,
	SUBMIT_APPLICATION_FORM_FILES_PENDING,
	SUBMIT_APPLICATION_FORM_FILES_FULFILLED,
	SUBMIT_APPLICATION_FORM_FILES_FAILED
} from '../constants/application.actions';

import {
	FETCH_PAGE_FULFILLED
} from '../constants/page.actions';

const applicationReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case SET_APPLICATION_LEVEL_FULFILLED: {
				draft.currentLevel = action.payload.level;
				break;
			}
			case SUBMIT_APPLICATION_FORM_PENDING: {
				draft.formSubmissionLoading = true;
				draft.formSubmissionError = false;
				draft.formSubmissionErrorMessage = null;
				draft.formSubmissionErrorStatus = null;
				draft.fileSubmissionLoading = false;
				draft.fileSubmissionError = false;
				break;
			}
			case SUBMIT_APPLICATION_FORM_FULFILLED: {
				draft.fileSubmissionLoading = true;
				draft.activeApplicationId = action.payload.applicationId;
				break;
			}
			case SUBMIT_APPLICATION_FORM_FILES_PENDING: {
				draft.fileSubmissionLoading = true;
				draft.fileSubmissionError = false;
				break;
			}
			case SUBMIT_APPLICATION_FORM_FAILED: {
				draft.formSubmissionLoading = false;
				draft.formSubmissionError = true;
				draft.formSubmissionErrorMessage = action.payload.message;
				draft.formSubmissionErrorStatus = action.payload.status;
				draft.fileSubmissionLoading = false;
				draft.fileSubmissionError = false;
				break;
			}
			case SUBMIT_APPLICATION_FORM_FILES_FULFILLED: {
				// The API returns the files flagged with messages whether uploading them was succesful or not
				const invalidFiles = action.payload.files.filter(x => !x.Success || x.ExcessiveFileSize || x.InvalidExtension);

				draft.invalidFiles = invalidFiles;
				// If there are any invalid files we go back to the error state
				draft.fileSubmissionError = invalidFiles.length > 0;
				// If there are any invalid files we stay at step 2, otherwise we go to the form submissed step
				draft.currentLevel = invalidFiles.length === 0 ? 3 : 2;
				draft.formSubmissionSuccessful = invalidFiles.length === 0;
				draft.formSubmissionLoading = false;
				draft.formSubmissionError = false;
				draft.fileSubmissionLoading = false;
				break;
			}
			case SUBMIT_APPLICATION_FORM_FILES_FAILED: {
				draft.formSubmissionLoading = false;
				draft.fileSubmissionLoading = false;
				draft.fileSubmissionError = true;
				break;
			}
			case FETCH_PAGE_FULFILLED: {
				// When routing between pages, reset the form
				// if it has been turned in successfully
				if(draft.formSubmissionSuccessful) {
					draft.currentLevel = 1;
					draft.activeApplicationId = 0;
					draft.formSubmissionLoading = false;
					draft.formSubmissionError = false;
					draft.fileSubmissionLoading = false;
					draft.fileSubmissionError = false;
					draft.invalidFiles = [];
					draft.formSubmissionSuccessful = false;
				}
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		currentLevel: 1,
		activeApplicationId: 0,
		formSubmissionLoading: false,
		formSubmissionError: false,
		fileSubmissionLoading: false,
		fileSubmissionError: false,
		invalidFiles: [],
		formSubmissionSuccessful: false
	}
);

export default applicationReducer;
